import React from 'react'
import { observer } from 'mobx-react'
import Button from 'components/Button'

import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
} from 'components/ModalSheet'

import styles from './ManageSkillsListDialog.sass'
import SearchField from 'components/SearchField'

import Checkbox from 'components/Checkbox'
import { ListItemDescription, ListItemTitle } from 'iam/components/ListItem'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import { ManageSkillsListViewModel } from './ManageSkillsListViewModel'

interface ManageSkillsListDialogProps {
  vm: ManageSkillsListViewModel
}

export const ManageSkillsListDialog = observer(
  ({ vm }: ManageSkillsListDialogProps) => {
    return (
      <ModalSheet
        showing={vm.showing}
        onRequestClose={vm.close}
        disableCloseOnOutsideClick
      >
        <ModalSheetHeader withCloseButton>
          <SearchField
            stretch
            embedded
            placeholder="Search skills"
            onChange={(value: string) => vm.setSearchText(value)}
          />
        </ModalSheetHeader>
        {vm.isWorkspaceSelected && (
          <ModalSheetContent>
            <ModalSheetSection spaced>
              <div className={styles.editSkill}>
                <table className={styles.editSkillTable}>
                  <thead>
                    <tr>
                      <th align="left">Skill</th>
                      <th align="right">Tags</th>
                      <th align="right">
                        <Checkbox
                          checked={vm.allSelected}
                          onChange={vm.selectAllSkills}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {vm.filteredSkills.map((skill) => (
                      <tr key={skill.id} className={styles.editSkillItemRow}>
                        <td align="left">
                          <ListItemTitle>{skill.name}</ListItemTitle>
                          <ListItemDescription>
                            {skill.description}
                          </ListItemDescription>
                        </td>
                        <td align="right">
                          <div className={styles.tagColumn}>
                            <ListItemDescription>
                              {skill.tags.map((tag) => tag.label).join(', ')}
                            </ListItemDescription>
                          </div>
                        </td>
                        <td align="right">
                          <Checkbox
                            checked={vm.skills.has(skill.id)}
                            onChange={() => vm.toggleSkill(skill)}
                            data-test={`edit-skills-row-checkbox-${skill.id}`}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <InfiniteScrollLoader scrollProvider={vm.scroller} />
            </ModalSheetSection>
          </ModalSheetContent>
        )}

        <ModalSheetFooter>
          <ModalSheetFooterSpacer />
          <ModalSheetFooterButtonGroup>
            <Button type="default" onClick={vm.close}>
              Close
            </Button>
            <Button
              type="primary"
              disabled={vm.submit.pending}
              dataTest="edit-skills-submit"
              onClick={vm.submit}
            >
              Save
            </Button>
          </ModalSheetFooterButtonGroup>
        </ModalSheetFooter>
      </ModalSheet>
    )
  },
)
